module.exports = __webpack_public_path__ + "56240c455a3317845d8c46171430ad79.pdf";